/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Container,
    Text,
    useMultiStyleConfig,
    Divider,
    Stack,
    Flex,
    Button,
} from '@chakra-ui/react'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import Seo from '@salesforce/retail-react-app/app/components/seo'
import LoginForm from '../../components/login'
// import useEinstein from '../../hooks/use-einstein'
import {FormattedMessage} from 'react-intl'
import RegistrationBenefits from '../../pages/account/registration-benefits/registration-benefits'

const Login = () => {
    const navigate = useNavigation()
    const stylesLogin = useMultiStyleConfig('Login')

    return (
        <Box {...stylesLogin.loginContainer} data-testid="login-page" data-gtm="login-page">
            <Seo title="Sign in" description="Customer sign in" />
            <Container {...stylesLogin.loginFormContainer}>
                <Text {...stylesLogin.myAccountTitle}>
                    <FormattedMessage
                        defaultMessage="My Account"
                        id="login_form.message.my_account"
                    />
                </Text>
                <Divider {...stylesLogin.horizontalDivider} />
                <Flex
                    w="100%"
                    justifyContent="space-between"
                    flexDirection={['column', 'column', 'row']}
                    gap="1rem"
                >
                    <LoginForm />
                    <Stack {...stylesLogin.registrationButtonLogin}>
                        <Text {...stylesLogin.newUser}>
                            <FormattedMessage
                                defaultMessage="New user?"
                                id="login_form.message.new_user"
                            />
                        </Text>
                        <Text {...stylesLogin.registerNow}>
                            <FormattedMessage
                                defaultMessage="Register now to benefit from owning an account:"
                                id="login_form.message.register_now"
                            />{' '}
                        </Text>
                        <Stack {...stylesLogin.registrationButtonStack}>
                            <Button
                                title="Register"
                                onClick={() => navigate('/registration')}
                                variant={'primary'}
                                {...stylesLogin.registrationButton}
                            >
                                <FormattedMessage
                                    defaultMessage="Register"
                                    id="login_form.message.register"
                                />
                            </Button>
                        </Stack>
                        <Stack {...stylesLogin.registrationBenefits}>
                            <Text {...stylesLogin.registrationTitle}>
                                <FormattedMessage
                                    defaultMessage="Your benefits"
                                    id="login_form.message.registration_title"
                                />
                            </Text>
                            <Text {...stylesLogin.registrationSutitle}>
                                <FormattedMessage
                                    defaultMessage="Join the De’Longhi family to take advantage of exclusive deals and a more customised experience."
                                    id="login_form.message.registration_subtitle"
                                />
                            </Text>
                            <RegistrationBenefits />
                        </Stack>
                    </Stack>
                </Flex>
            </Container>
        </Box>
    )
}

Login.getTemplateName = () => 'login'

Login.propTypes = {
    match: PropTypes.object,
}

export default Login
